/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Tracking_LockedInputs */

const vi_packaging_material_tracking_locked = /** @type {(inputs: Packaging_Material_Tracking_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không đổi được sau khi vật tư đã có tồn kho.`)
};

/**

* @param {Packaging_Material_Tracking_LockedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_tracking_locked = /** @type {((inputs?: Packaging_Material_Tracking_LockedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Tracking_LockedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_tracking_locked(inputs)
});